<template>
	<v-menu
		v-model="modal"
		:close-on-content-click="false"
		:nudge-right="40"
		transition="scale-transition"
		offset-y
		min-width="290px"
	>
		<template v-slot:activator="{ on }">
			<v-text-field
				v-model="dParsed"
				@input="$emit('input', value)"
				:label="label"
				prepend-icon="event"
				readonly
				clearable
				v-on="on"
				v-bind="$attrs"
			></v-text-field>
		</template>
		<v-date-picker
			v-bind="$attrs"
			v-model="dModel"
			@input="$emit('input', dModel); modal = false"
		>
		</v-date-picker>
	</v-menu>
</template>

<script>
	import * as moment from "moment";
	import "moment/locale/it";
	
	export default {
		props: {
			value: {
				type: String,
				default: null
			},

			label: {
				type: String,
				required: false,
				default: "Data"
			}
		},

		watch: {
			value(v) {
				this.dModel = v;
			}
		},

		data() {
			return {
				dModel: this.value,
				modal: false,
				date: null
			};
		},

		computed: {
			dParsed:{
				get() {
					return this.$filters.date(this.value);
				},

				set(value) {
					this.value = value;
				}
			}
		}
	}
</script>
